import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import InputTextComponent from './inputs/InputTextComponent';
import SimpleReactValidator from './validator';
import { t } from 'i18next';
import InputDropdownComponent from './inputs/InputDropdownComponent';
import LocationComponent  from "../components/LocationComponent";
import GeoCodingService from '../services/GeoCodingService';
import StringUtils from '../utils/StringUtils';
import LocationUtil from '../utils/LocationUtils';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import CopyLink from '../containers/CopyLink';
import InputNumberComponent from './inputs/InputNumberComponent';




export const LocationAddressComponent = ({
    validator,
    handleChange,
    handleChangeAddress,
    handleChangeLocation,
    handleChangeLocationTolerance,
    viewMode,
    stateField,
    initCountryLocation,
    addressLocation,
    countries,
    showErrorMessage,
    supportCustomAddress,
    customAddressLabel,
    showLocationTolerance,
    baseAddress
})=> {
    const initValueAddressIsCustom = () => {

        if (!baseAddress || !addressLocation?.address?.country) {

            return false;
        }
        const isSameAddress = baseAddress?.country?.name === addressLocation?.address?.country?.name
            && baseAddress?.postalCode === addressLocation?.address?.postalCode
            && baseAddress?.city === addressLocation?.address?.city
            && baseAddress?.streetName === addressLocation?.address?.streetName
            && baseAddress?.streetNumber === addressLocation?.address?.streetNumber;   
        return !isSameAddress;

    }
    const latitude = addressLocation?.location?.latitude;
    const longitude = addressLocation?.location?.longitude;
    const locationToleranceInKilometers = addressLocation?.locationToleranceInKilometers;

    const [countryLocation, setCountryLocation] = useState(initCountryLocation);
    const [locations, setLocations] = useState(() => (latitude && longitude ? [{ longitude, latitude, locationToleranceInKilometers}] : []));
    const geoCodingService =  new GeoCodingService();
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [addressIsCustom, setAddressIsCustom] = useState(initValueAddressIsCustom());


    useEffect(() => {
        setCountryLocation(initCountryLocation);
    }, [initCountryLocation]);
  
    useEffect(() => {
        if (latitude && longitude) {
            setLocations([{ longitude, latitude, locationToleranceInKilometers}]);
        } else {
            setLocations([]);
        }
    }, [latitude, longitude, locationToleranceInKilometers]);

   
    useEffect(() => {
        if (!addressIsCustom && supportCustomAddress) {
            const address = {
                city : baseAddress?.city,
                country : baseAddress?.country,
                streetNumber : baseAddress?.streetNumber,
                postalCode : baseAddress?.postalCode,
                streetName : baseAddress?.streetName,
            }
            findMarker(address);
            handleChangeAddress(address);            
        }

    }, [JSON.stringify(baseAddress), addressIsCustom]);


    const areBaseLocationFieldsEmpty = (a) => {
        let address = a;
        if (!address) {
            address = addressLocation?.address;
        }
        return StringUtils.isBlank(address?.streetName) && StringUtils.isBlank(address?.postalCode) && StringUtils.isBlank(address?.city);
    };
    
    const setInitLocation = (callback, a) => {
        let address = a;
        if (!address) {
            address = addressLocation?.address;
        }
        const paramsObj = { country: address?.country?.name};
        const afterCountryFound = (coordinates) => {
            if(callback){
                callback()
            }
            setCountryLocation([
                coordinates[0],
                coordinates[1],
            ])
        } 
        const countryLocation =  LocationUtil.getCountryLocation(paramsObj.country);
        if(StringUtils.isBlank(countryLocation)){
            geoCodingService.getCoordinates(paramsObj)
            .then((res) => {
                const {coordinates} =  res.geometry;
                afterCountryFound(coordinates);
            });
        }
        else {
                afterCountryFound(countryLocation);
        }
        return;
    }

    const findMarker = (a) => {
        let address = a;
        if (!address || !a.country) {            
            address = addressLocation?.address;
        } 
        if(areBaseLocationFieldsEmpty(address)){
            handleChangeLocation([])
            return;
        }
        const paramsObj = {
            country: address?.country?.name,
            street_name:  address?.streetName,
            street_number: address?.streetNumber,
            postal_code: address?.postalCode,
            city: address?.city,
            house_number: address?.houseNumber,
        };
        geoCodingService.getCoordinates(paramsObj).then((res)=>{
            const {address} =  res.properties;
            const {coordinates} =  res.geometry;
            const country = getCountry(address.country);
            if(StringUtils.isBlank(paramsObj.country) && !StringUtils.isBlank(country)){
                setCountryLocation([
                    coordinates[1],
                    coordinates[0],
                ])
                paramsObj.country = country;
                handleChangeAddress(paramsObj);
            }
            handleChangeLocation([{
                longitude: coordinates[0],
                latitude: coordinates[1],
            }])
        }).catch((res)=>{ 
            if(res?.errorCode !== "LOCATION_NOT_FOUND"){
                showErrorMessage(t("project.localizationNotFound"));
            }
            handleChangeLocation([])
        })
    };

    const findAddress = (longitude, latitude) => {
        const paramsObj = {
            longitude: longitude,
            latitude: latitude,
        };
        geoCodingService.getAddress(paramsObj).then((res)=>{
            const {address} =  res.properties;
            handleChangeLocation([{
                longitude: paramsObj.longitude,
                latitude: paramsObj.latitude,
            }])
            const country = getCountry(address.country);
            const responseAddress = {
                city : returnEmptyIfBlank(address.city),
                country : returnEmptyIfBlank(country),
                streetNumber : returnEmptyIfBlank(address.houseNumber),
                postalCode : returnEmptyIfBlank(address.postCode),
                streetName : returnEmptyIfBlank(address.road),
            }
            validator.hideMessages();
            handleChangeAddress(responseAddress);
        }).catch((res)=>{
            if(res?.errorCode !== "LOCATION_NOT_FOUND"){
                showErrorMessage(t("project.localizationNotFound"));
            }
            handleChangeLocation([])
        })
    }
    const handleOnAfterStateChange = () => {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        const timeout = setTimeout(() => {
            findMarker();
        }, 1200); 
        setDebounceTimeout(timeout); 
    };

    const getCountry = (countryFromResponse) =>{
        let result = undefined;
        if(!StringUtils.isBlank(countryFromResponse) ){
            if(countryFromResponse.toUpperCase()=== "NIDERLANDY"){
                countryFromResponse = "Holandia";
            }
            result = countries.find(country=>country.name.toUpperCase() === countryFromResponse.toUpperCase());
        }
        return result;
    }

    const returnEmptyIfBlank = (el) => {
       return StringUtils.isBlank(el) ? '' : el
    }

    const onLocatlizationChange = (marker) => {
        if(StringUtils.isBlank(marker)){
            handleChangeLocation([])
            const responseAddress = {
                city :'',
                country :'',
                streetNumber :'',
                postalCode : '',
                streetName : '',
            }
            handleChangeAddress(responseAddress);
            return
        }
        findAddress(marker.longitude, marker.latitude)
    }


    const formatAddressCity = () => {
        let result = '';
        let postalCodeSet = false;
        if (addressLocation?.address?.postalCode) {
            result += addressLocation?.address?.postalCode;
            postalCodeSet = true;
        }
        if (addressLocation?.address?.city) {
            if (postalCodeSet) {
                result += ' ';
            }
            result += addressLocation?.address?.city;
        }
        return result;
    }

    const formatAddressStreet = () => {
        let result = '';
        let streeNameSet = false;
        if (addressLocation?.address?.streetName) {
            result += addressLocation?.address?.streetName;
            streeNameSet = true;
        }
        if (addressLocation?.address?.streetNumber) {
            if (streeNameSet) {
                result += ' ';
            }
            result += addressLocation?.address?.streetNumber;
        }
        if (addressLocation?.address?.houseNumber) {
            result += '/' + addressLocation?.address?.houseNumber;
        }
        return result;
    }


    const formatAddress = () => {
        let result = addressLocation?.address?.country?.name;
        result += ', ';
        result += formatAddressCity();
        result += ', ';
        result += formatAddressStreet();
        return result;
    }

    return  (
        <React.Fragment>            
            <div className='row '>
                <div className='col-8' >
                  <LocationComponent 
                        viewMode={viewMode} 
                        showLocationTolerance={showLocationTolerance} 
                        onAddLocation={(marker)=>{
                            onLocatlizationChange(marker)
                        }} 
                        onUpdateLocation={(markers) => {                            
                            setAddressIsCustom(true);
                            onLocatlizationChange(markers[0])
                            if(markers.length === 0){
                                handleChangeLocationTolerance(0);
                            }
                        }}
                        onUpdateLocationTolerance={(markers)=>{
                            handleChangeLocationTolerance(markers[0].locationToleranceInKilometers);
                        }}
                        locations={locations} 
                        initLocation={countryLocation}
                        showErrorMessage={showErrorMessage}
                    /> 
                </div>
                <div className='col-4' >
                    <Card                        
                        className='data-card localization'
                        header={                            
                            <div className='card-header-with-icon-container'>
                                <i className='mdi mdi-map-marker-radius' />
                                {viewMode === 'VIEW' ? (
                                    <label htmlFor="isCustomAddress" className="col-12">Adres</label>
                                ) : supportCustomAddress ? (                                    
                                    <React.Fragment>
                                        <Checkbox name='isCustomAddress' id='isCustomAddress' checked={addressIsCustom} style={{marginRight: '10px'}} onChange={e => {                                            
                                            setAddressIsCustom(e.checked);
                                        }} />
                                        <label htmlFor="isCustomAddress" className="col-12">{customAddressLabel}</label>
                                    </React.Fragment>
                                ) : (
                                    <label htmlFor="isCustomAddress" className="col-12">Adres</label>
                                )}
                                
                            </div>
                        }                        
                    >
                        {viewMode === 'VIEW' ? (
                            <React.Fragment>
                                <InputTextComponent 
                                    viewMode='VIEW' showLabel={false}
                                    value={addressLocation?.address?.country?.name}
                                    colClass='col-12'
                                    id='addressViewMode-country'
                                    name='addressViewMode-country'
                                />
                                <InputTextComponent 
                                    viewMode='VIEW' showLabel={false}
                                    value={formatAddressCity()}
                                    colClass='col-12'
                                    id='addressViewMode-city'
                                    name='addressViewMode-city'
                                />
                                <InputTextComponent 
                                    viewMode='VIEW' showLabel={false}
                                    value={formatAddressStreet()}
                                    colClass='col-12'
                                    id='addressViewMode-street'
                                    name='addressViewMode-street'
                                />
                                <CopyLink textToCopy={formatAddress()} defaultText={'Skopiuj adres'}/>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {addressIsCustom || !supportCustomAddress? (
                                    <InputDropdownComponent
                                        id='country'
                                        name='country'
                                        label={t('address.country')}
                                        colClass='col-12'
                                        value={addressLocation?.address?.country}
                                        validator={validator}
                                        options={countries}                        
                                        //onAfterStateChange={()=> {                                            
                                            //setInitLocation(()=>findMarker(), true)
                                        //}}
                                        onChange={(a,b,c,d,e,f) => {    
                                            const address = {
                                                city : '',
                                                country : c.value,
                                                streetNumber : '',
                                                postalCode : '',
                                                streetName : '',
                                            };
                                            handleChangeAddress(address, () => setInitLocation(()=>findMarker(), address));
                                            
                                        }}
                                        viewMode={viewMode}
                                        optionLabel='name'
                                        dataKey='id'
                                        validators='required'
                                        valueView={addressLocation?.address?.country?.name}
                                        stateField={stateField}
                                        filter
                                        filterBy='name'
                                    />
                                ) : (
                                    <InputTextComponent
                                        id='country'
                                        name='country'
                                        label={t('address.country')}
                                        colClass='col-12'                        
                                        value={addressLocation?.address?.country?.name}
                                        viewMode={"EDIT"}
                                        disabled={!addressIsCustom}
                                        stateField={stateField}
                                    />                                    
                                )}
                                <InputTextComponent
                                    id='postalCode'
                                    name='postalCode'
                                    onAfterStateChange={()=>handleOnAfterStateChange()}
                                    label={t('address.postalCode')}
                                    colClass='col-12'
                                    value={addressLocation?.address?.postalCode}
                                    validator={validator}
                                    validators='not_required|max:10'
                                    onChange={handleChange}
                                    viewMode={"EDIT"}
                                    disabled={!addressIsCustom && supportCustomAddress}
                                    stateField={stateField}
                                />
                                <InputTextComponent
                                    id='city'
                                    name='city'
                                    label={t('address.city')}
                                    colClass='col-12'                        
                                    onAfterStateChange={()=>handleOnAfterStateChange()}
                                    value={addressLocation?.address?.city}
                                    validator={validator}
                                    validators='not_required|max:100'
                                    onChange={handleChange}
                                    viewMode={"EDIT"}
                                    disabled={!addressIsCustom && supportCustomAddress}
                                    stateField={stateField}
                                />
                        
                                <InputTextComponent
                                    id='streetName'
                                    name='streetName'
                                    label={t('address.streetName')}
                                    colClass='col-12'                        
                                    onAfterStateChange={()=>handleOnAfterStateChange()}
                                    value={addressLocation?.address?.streetName}
                                    validator={validator}
                                    validators='not_required|max:100'
                                    onChange={handleChange}
                                    viewMode={"EDIT"}
                                    disabled={!addressIsCustom && supportCustomAddress}
                                    stateField={stateField}
                                />
                                <InputTextComponent
                                    id='streetNumber'
                                    name='streetNumber'
                                    label={t('address.streetNumber')}
                                    colClass='col-lg-6 col-md-12'                        
                                    onAfterStateChange={()=>handleOnAfterStateChange()}
                                    value={addressLocation?.address.streetNumber}
                                    validator={validator}
                                    validators='not_required|max:100'
                                    onChange={handleChange}
                                    viewMode={"EDIT"}
                                    disabled={!addressIsCustom && supportCustomAddress}
                                    stateField={stateField}
                                />
                                <InputTextComponent
                                    id='houseNumber'
                                    name='houseNumber'
                                    label={t('address.houseNumber')}
                                    colClass='col-lg-6 col-md-12'            
                                    onAfterStateChange={()=>handleOnAfterStateChange()}
                                    value={addressLocation?.address?.houseNumber}
                                    validator={validator}
                                    validators='not_required|max:20'
                                    onChange={handleChange}
                                    viewMode={"EDIT"}
                                    disabled={!addressIsCustom && supportCustomAddress}
                                    stateField={stateField}
                                />
                                {showLocationTolerance && <InputNumberComponent
                                    id='locationToleranceInKilometers'
                                    name='locationToleranceInKilometers'
                                    label={t('global.distanceToleranceInKilometers')}
                                    colClass='col-lg-6 col-md-12'         
                                    textAlign={"left"}   
                                    value={locationToleranceInKilometers}
                                    validator={validator}
                                    minFractionDigits={2}
                                    min={0}
                                    validators='not_required'
                                    onChange={(a,b,c,d)=>{
                                        handleChangeLocationTolerance(c.value)
                                    }}
                                    viewMode={"EDIT"}
                                    stateField={stateField}
                                />}
                               
                            </React.Fragment>
                        )}
                    </Card>
                </div>
               
            </div>
        </React.Fragment>
    );
    
}

LocationAddressComponent.defaultProps = {
    element: null,
    viewMode: 'VIEW',
    stateField: 'element.projectAddress.address',
    colClass: 'col-md-4',
    supportCustomAddress: false,
    showLocationTolerance: false,
};

LocationAddressComponent.propTypes = {
    element: PropTypes.object,
    stateField: PropTypes.string,
    viewMode: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleChangeAddress: PropTypes.func.isRequired,
    handleChangeLocation: PropTypes.func.isRequired,
    handleChangeLocationTolerance: PropTypes.func,
    validator: PropTypes.instanceOf(SimpleReactValidator).isRequired,
    colClass: PropTypes.string,
    initCountryLocation: PropTypes.array,
    countries: PropTypes.array,
    showErrorMessage: PropTypes.func,
    supportCustomAddress: PropTypes.bool,
    showLocationTolerance: PropTypes.bool,
    customAddressLabel: PropTypes.string,
    baseAddress: PropTypes.object,
};
